import { motion } from "framer-motion";
import { Check, FileDown, MessageCircle } from "lucide-react";
import { API } from "@/lib/api";

export default function SuccessCard({ name, t }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="bg-white rounded-3xl border border-line p-8 sm:p-12 text-center shadow-[0_30px_70px_-40px_rgba(28,36,30,0.35)]"
      data-testid="success-card"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.25, type: "spring", stiffness: 200, damping: 14 }}
        className="mx-auto mb-8 grid place-items-center h-20 w-20 rounded-full bg-sage"
      >
        <Check className="h-10 w-10 text-white" strokeWidth={3} />
      </motion.div>
      <h3 className="font-serif text-3xl sm:text-4xl tracking-tight mb-4" data-testid="success-title">
        {t.thanks}{name ? `, ${name}` : ""}!
      </h3>
      <p className="text-base leading-relaxed text-stonemute max-w-md mx-auto mb-10">
        {t.body1}{" "}
        <span className="font-semibold text-ink">{t.bodyStrong}</span>{t.body2}
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <motion.a
          href={`${API}${t.downloadPath}`}
          download={t.downloadName}
          data-testid="download-guide-button"
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center gap-3 rounded-full bg-sage px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-sage-dark"
        >
          <FileDown className="h-5 w-5" /> {t.download}
        </motion.a>
        <motion.a
          href={t.waUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="success-whatsapp-button"
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-[#1eb85a]"
        >
          <MessageCircle className="h-5 w-5" /> {t.whats}
        </motion.a>
      </div>
      <p className="mt-8 text-xs uppercase tracking-[0.2em] text-stonemute" data-testid="success-stand-note">
        {t.note}
      </p>
    </motion.div>
  );
}
